export const socialsData = {
    github: 'https://github.com/ptrkalm',
    facebook: 'https://www.facebook.com/piotrkalmuczak',
    linkedIn: 'https://www.linkedin.com/in/ptrkalm',
}